import { render, staticRenderFns } from "./TechnicalManager.vue?vue&type=template&id=5bbba8ea&scoped=true"
import script from "./TechnicalManager.vue?vue&type=script&lang=js"
export * from "./TechnicalManager.vue?vue&type=script&lang=js"
import style0 from "./TechnicalManager.vue?vue&type=style&index=0&id=5bbba8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbba8ea",
  null
  
)

export default component.exports